import { useTranslation } from "react-i18next";
import i18n from "src/i18n/config";
import { z } from "zod";

import { FileContentType } from "@dashboard/files/types";
import { PartitionLayoutModule, Product } from "@dashboard/products/types";

import { ModuleFileDialog, ModuleFileFormValues } from "./ModuleFileDialog";

const schema = z.object({
    fileId: z.string({ message: i18n.t("common:validation.fieldRequired") }),
});

type Props = {
    product: Product | null;
    open: boolean;
    onToggle: (value: boolean) => void;
};

const contentTypes = [FileContentType.Json];
const uploadExtensions = ["json"];

export const PartitionLayoutDialog = (props: Props) => {
    const { t } = useTranslation(["modals"]);

    const currentModule = props.product?.customBuildConfig?.modules.find(
        (item): item is PartitionLayoutModule => item.type === "partition_layout",
    );

    return (
        <ModuleFileDialog<ModuleFileFormValues, PartitionLayoutModule>
            product={props.product}
            module={currentModule ?? null}
            open={props.open}
            onToggle={props.onToggle}
            title={t("modals:manageProductModules.partitionLayout.title")}
            description={t("modals:manageProductModules.partitionLayout.description")}
            noFilesAvailable={t("modals:manageProductModules.partitionLayout.noFilesAvailable")}
            contentTypes={contentTypes}
            uploadExtensions={uploadExtensions}
            schema={schema}
            newModuleDefaults={{ type: "partition_layout", tags: ["Build"] }}
            buildModuleValues={(_file, sourceId) => ({ sourceId })}
        />
    );
};
